import { Controller } from 'stimulus'
import i18nSetup from "../i18n-setup"

export default class UnavailableController extends Controller {
  static targets = [ 'content' ]

  initialize() {
    this.i18n = i18nSetup()
  }

  showUnavailablePopup(e) {
    e.preventDefault()
    this.build()
    this.show()
    this.hide()
  }

  build() {
    let popupSettings = {
      on: 'click',
      delay: {
        show:  50,
        hide: 200
      },
      exclusive: true,
      inline: true,
      content: this.i18n.t('web.javascript.unavailable_content'),
      position: 'top right'
    }

    this.destroy()

    $(this.contentTarget).popup(popupSettings)
  }

  show() {
    $(this.contentTarget).popup('show')
  }

  hide() {
    this.timeout = setTimeout(() => this.destroy(), 2000)
  }

  destroy() {
    $(this.contentTarget).next('.ui.popup').remove()
    clearTimeout(this.timeout)
  }
}
